/**
 * Analytics composition point.
 *
 * Selects the real or no-op emitter based on environment:
 *   - Production (`import.meta.env.PROD`): real CollectorEmitter → POSTs to /e.
 *   - Development with `VITE_ANALYTICS=1`: also real, for manual pipeline testing.
 *   - All other dev/test contexts: no-op emitter (enabled=false, zero overhead).
 *
 * No other file needs to change to swap emitters — this is the single composition
 * point (mirrors the pattern from the previous placeholder comment).
 *
 * The DNT check lives inside CollectorEmitter: if the user has DNT set, the
 * emitter's `enabled` is false and nothing is ever sent, regardless of env.
 */
import type { AnalyticsEmitter } from 'briefpane/contracts';
import { createNoOpEmitter } from './no-op-emitter.js';
import { createCollectorEmitter } from './collector-emitter.js';

export { createNoOpEmitter } from './no-op-emitter.js';
export { createCollectorEmitter } from './collector-emitter.js';
export { getIdentity, buildEnvelope } from './identity.js';

function makeEmitter(): AnalyticsEmitter {
  const isProduction = import.meta.env.PROD === true;
  const devOverride = import.meta.env.VITE_ANALYTICS === '1';

  if (isProduction || devOverride) {
    return createCollectorEmitter();
  }
  return createNoOpEmitter();
}

export const appAnalytics: AnalyticsEmitter = makeEmitter();
